// extracted by mini-css-extract-plugin
export default {"overlay-modal":"modal_overlay-modal__5Etb3","modal":"modal_modal__H4mo9","container-btn":"modal_container-btn__a45Mv"};